document.addEventListener('DOMContentLoaded', function() {
  const elements = {
    wrapper: document.getElementById('cepModalWrapper'),
    toggle: document.getElementById('cepToggle'),
    mobileToggle: document.getElementById('cepMobileToggle'),
    close: document.getElementById('cepClose'),
    overlay: document.getElementById('cepOverlay'),
    input: document.getElementById('cepInput'),
    submit: document.getElementById('cepSubmit'),
    gps: document.getElementById('cepGps'),
    mobileBar: document.getElementById('cepMobileBar'),
    emptyState: document.getElementById('cepStateEmpty'),
    filledState: document.getElementById('cepStateFilled'),
    cityDisplay: document.getElementById('userCityDisplay'),
    cepDisplay: document.getElementById('userCepDisplay'),
    mobileText: document.getElementById('mobileUserText')
  };

  if (!elements.toggle || !elements.wrapper || !elements.input || !elements.submit) return;

  
  
  
  if (elements.mobileBar) {
    var drawerFooter = document.querySelector('#MenuDrawer .custom-drawer__footer');
    if (drawerFooter) {
      drawerFooter.insertAdjacentElement('beforebegin', elements.mobileBar);
      elements.mobileBar.classList.add('cep-mobile-bar--in-drawer');
    } else {
      var header = document.querySelector('header');
      if (header) header.insertAdjacentElement('afterend', elements.mobileBar);
    }
  }

  
  
  
  
  
  
  if (elements.wrapper && elements.wrapper.parentElement !== document.body) {
    document.body.appendChild(elements.wrapper);
  }

  
  
  
  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    const focusables = elements.wrapper.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openModal() {
    elements.wrapper.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    elements.toggle.setAttribute('aria-expanded', 'true');
    if (elements.mobileToggle) elements.mobileToggle.setAttribute('aria-expanded', 'true');
    
    elements.wrapper.addEventListener('keydown', trapFocus);
    
    setTimeout(() => elements.input.focus(), 220);
  }

  function closeModal() {
    elements.wrapper.style.display = 'none';
    document.body.style.overflow = '';
    elements.toggle.setAttribute('aria-expanded', 'false');
    if (elements.mobileToggle) elements.mobileToggle.setAttribute('aria-expanded', 'false');
    
    elements.wrapper.removeEventListener('keydown', trapFocus);
    
    elements.toggle.focus();
  }

  elements.toggle.addEventListener('click', openModal);
  
  elements.toggle.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(); }
  });
  if(elements.mobileToggle) elements.mobileToggle.addEventListener('click', openModal);
  if (elements.close) elements.close.addEventListener('click', closeModal);
  if (elements.overlay) elements.overlay.addEventListener('click', closeModal);
  
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && elements.wrapper.style.display === 'flex') closeModal();
  });

  elements.input.addEventListener('input', (e) => {
    let v = e.target.value.replace(/\D/g, '');
    if (v.length > 5) v = v.replace(/^(\d{5})(\d)/, '$1-$2');
    e.target.value = v;
  });

  
  
  
  function updateUI(city, cep) {
    if (!city) return;
    const cleanCity = city.replace(/Região Metropolitana de /i, "").split(',')[0];
    const cleanCep = (cep && cep.match(/\d/)) ? cep : "";

    if(elements.emptyState) elements.emptyState.style.display = 'none';
    if(elements.filledState) {
      elements.filledState.style.display = 'flex';
      elements.cityDisplay.innerText = cleanCity;
      elements.cepDisplay.innerText = cleanCep;
    }

    if(elements.mobileText) elements.mobileText.innerText = `${cleanCity}${cleanCep ? ', ' + cleanCep : ''}`;
    if(elements.mobileBar) elements.mobileBar.style.display = 'block';

    const dadosLocalizacao = { city: cleanCity, cep: cleanCep };
    localStorage.setItem('localizacao_cliente', JSON.stringify(dadosLocalizacao));
    
    window.dispatchEvent(new CustomEvent('cep_atualizado', { detail: dadosLocalizacao }));
  }

  const setButtonLabel = (btn, label) => {
    const textEl = btn.querySelector('.btn__text');
    if (textEl) {
      const nonTextNodes = Array.from(textEl.childNodes).filter(n => n.nodeType !== Node.TEXT_NODE);
      textEl.textContent = '';
      nonTextNodes.forEach(n => textEl.appendChild(n));
      textEl.appendChild(document.createTextNode(' ' + label));
    } else {
      btn.textContent = label;
    }
  };

  const setInputError = (hasError) => {
    if (hasError) elements.input.dataset.state = 'error';
    else delete elements.input.dataset.state;
  };

  elements.submit.addEventListener('click', () => {
    const val = elements.input.value.replace(/\D/g, '');
    if(val.length === 8) {
      setInputError(false);
      setButtonLabel(elements.submit, '...');
      elements.submit.disabled = true;
      fetch(`https://viacep.com.br/ws/${val}/json/`)
        .then(r => {
          if (!r.ok) throw new Error('network');
          return r.json();
        })
        .then(d => {
          if(!d.erro) {
            updateUI(d.localidade, d.cep);
            closeModal();
          } else {
            setInputError(true);
            elements.input.focus();
          }
        })
        .catch(() => {
          setInputError(true);
          elements.input.focus();
        })
        .finally(() => {
          setButtonLabel(elements.submit, 'OK');
          elements.submit.disabled = false;
        });
    } else {
      setInputError(true);
      elements.input.focus();
    }
  });

  elements.input.addEventListener('focus', () => setInputError(false));

  if (elements.gps) elements.gps.addEventListener('click', () => {
    if (!navigator.geolocation) return alert('GPS não suportado.');

    setButtonLabel(elements.gps, 'Localizando...');
    elements.gps.disabled = true;

    navigator.geolocation.getCurrentPosition((pos) => {
      const url = `https://nominatim.openstreetmap.org/reverse?lat=${pos.coords.latitude}&lon=${pos.coords.longitude}&format=json`;
      
      fetch(url)
        .then(r => r.json())
        .then(d => {
          const city = d.address.city || d.address.town || d.address.village || d.address.suburb;
          const cep = d.address.postcode || "";
          if(city) {
            updateUI(city, cep);
            closeModal();
          } else { alert('Não foi possível identificar a cidade.'); }
        })
        .catch(() => alert('Erro na conexão com o serviço de mapas.'))
        .finally(() => {
          setButtonLabel(elements.gps, 'Usar localização atual');
          elements.gps.disabled = false;
        });
    }, (err) => {
      alert('Por favor, ative a localização no seu celular/computador.');
      setButtonLabel(elements.gps, 'Usar localização atual');
      elements.gps.disabled = false;
    }, { enableHighAccuracy: true, timeout: 5000 });
  });

  const saved = localStorage.getItem('localizacao_cliente');
  if(saved) {
    try {
      const d = JSON.parse(saved);
      updateUI(d.city, d.cep);
    } catch(e) { console.error("Erro ao ler LocalStorage", e); }
  }
});